import React from 'react';
import { CalendarIcon, ClockIcon, MonitorIcon, TimerIcon, CheckCircle2Icon } from 'lucide-react';
import { useRegistration } from './RegistrationContext';
export const WebinarDetailsCard = () => {
  const {
    openPopup
  } = useRegistration();
  return <section className="mb-12" data-id="element-453">
      <div className="bg-blue-50 border border-blue-100 rounded-xl p-8" data-id="element-454">
        <div className="flex items-center gap-3 mb-6" data-id="element-455">
          <CalendarIcon className="w-6 h-6 text-blue-600" data-id="element-456" />
          <h3 className="text-xl font-bold text-gray-900" data-id="element-457">
            Het volgende <span className="text-blue-600" data-id="element-458">webinar</span>
          </h3>
        </div>

        <div className="space-y-5 mb-8" data-id="element-459">
          <div className="flex items-center" data-id="element-460">
            <CalendarIcon className="w-6 h-6 text-blue-400 mr-4 flex-shrink-0" data-id="element-461" />
            <p className="text-lg text-gray-800" data-id="element-462">
              <span className="font-bold" data-id="element-463">Datum:</span> vandaag en morgen
            </p>
          </div>
          <div className="flex items-center" data-id="element-464">
            <ClockIcon className="w-6 h-6 text-blue-400 mr-4 flex-shrink-0" data-id="element-465" />
            <p className="text-lg text-gray-800" data-id="element-466">
              <span className="font-bold" data-id="element-467">Tijd:</span> 10u, 13u, & 20u
            </p>
          </div>
          <div className="flex items-center" data-id="element-468">
            <MonitorIcon className="w-6 h-6 text-blue-400 mr-4 flex-shrink-0" data-id="element-469" />
            <p className="text-lg text-gray-800" data-id="element-470">
              <span className="font-bold" data-id="element-471">Locatie:</span> Online (link wordt na
              registratie verstuurd)
            </p>
          </div>
          <div className="flex items-center" data-id="element-472">
            <TimerIcon className="w-6 h-6 text-blue-400 mr-4 flex-shrink-0" data-id="element-473" />
            <p className="text-lg text-gray-800" data-id="element-474">
              <span className="font-bold" data-id="element-475">Duur:</span> 90 minuten
            </p>
          </div>
          <div className="flex items-center" data-id="element-476">
            <CheckCircle2Icon className="w-6 h-6 text-green-500 mr-4 flex-shrink-0" data-id="element-477" />
            <p className="text-lg text-gray-800" data-id="element-478">
              <span className="font-bold" data-id="element-479">Kosten:</span> 100% GRATIS
            </p>
          </div>
        </div>

        <div className="bg-white border border-gray-200 rounded-lg p-5 mb-6" data-id="element-480">
          <p className="font-bold text-gray-900 mb-2 italic" data-id="element-481">Belangrijk:</p>
          <p className="text-gray-600 leading-relaxed" data-id="element-482">
            Er zijn beperkte plekken beschikbaar per uitzending. Elke maand
            melden zich meer mensen aan, dus reserveer snel je plek!
          </p>
        </div>

        <button onClick={openPopup} className="w-full bg-green-700 hover:bg-green-800 text-white font-bold py-4 px-6 rounded-xl transition-colors text-lg" data-id="element-483">
          RESERVEER MIJN PLEK - GRATIS AANMELDEN
        </button>
      </div>
    </section>;
};